import hoverintent from 'hoverintent'

const preloadLinks = () => {
  const hoverIntentOptions = {
    interval: 50,
    sensitivity: 5
  };

  document.querySelectorAll('a').forEach(node => {
    if (!node.dataset.preloadlink) {
      return;
    }
    if (node.dataset.turbolinks === 'false') {
      return;
    }
    let prefetcher;
    hoverintent(
      node,
      function () {
        const href = this.getAttribute('href');
        if (!href.match(/^\//)) {
          return;
        }

        if (prefetcher) {
          if (prefetcher.getAttribute('href') !== href) {
            prefetcher.getAttribute('href', href);
          }
        } else {
          const link = document.createElement('link');
          link.setAttribute('rel', 'prefetch');
          link.setAttribute('href', href);

          prefetcher = document.body.appendChild(link);
        }
      },
      () => {return;}
    ).options(hoverIntentOptions)
  })
}

export default preloadLinks